<button (click)="scrollToTop()" class="prf-scroll-to-top-button">Наверх</button>
